import React from 'react';
import styles from './Footer.module.scss';

import {ReactComponent as LogoColor} from '../../assets/logo-color.svg';
import { Link } from '../ui/Link';

export class Footer extends React.Component
{
	render()
	{
		return (
			<footer className={styles['footer']}>
				<div className={styles['left']}>
					<Link href={'/'} className={styles['logo']} arrow={false} decoration={false}>
						<img src={'assets/logo-color.svg'} />
					</Link>
				</div>
				<div className={styles['right']}>
					Copyright© MLIT Japan. All Rights Reserved.
					<Link decoration={false} href={'https://www.mlit.go.jp/plateau/'}>Project PLATEAU WEB SITE</Link>
				</div>
			</footer>
		)
	}
}